import React from 'react';
import { CtaButton } from './CtaButton';
import { HeartMark } from './decor/HeartMark';
export function SiteHeader() {
  return <header className="sticky top-0 z-40 border-b border-cream-line/80 bg-cream/90 backdrop-blur" data-id="element-315" data-mp="19uq6qv6f824m">
      <div className="mx-auto flex h-16 max-w-content items-center justify-between px-5 sm:px-8" data-id="element-316" data-mp="1nmel754572or">
        <a href="#top" className="flex items-center gap-2 text-navy" data-id="element-317" data-mp="1iod2wmejj7ec">
          <HeartMark className="h-5 w-5 text-coral" data-id="element-318" data-mp="uxh3p47r99x2" />
          <span className="font-display text-xl leading-none" data-id="element-319" data-mp="v0bpaz2i90s2">Pack Complet</span>
          <span className="hidden text-xs font-bold uppercase tracking-[0.14em] text-gold-deep sm:inline" data-id="element-320" data-mp="qy8dg9bxbu69">d’Évangélisation</span>
        </a>
        <CtaButton size="md" data-id="element-321" data-mp="zxllcxkegaov">Accéder</CtaButton>
      </div>
    </header>;
}